import { render, staticRenderFns } from "./vToggleSwitchSelfHandled.vue?vue&type=template&id=aa2fe9f4&scoped=true"
import script from "./vToggleSwitchSelfHandled.vue?vue&type=script&lang=ts"
export * from "./vToggleSwitchSelfHandled.vue?vue&type=script&lang=ts"
import style0 from "./vToggleSwitchSelfHandled.vue?vue&type=style&index=0&id=aa2fe9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2fe9f4",
  null
  
)

export default component.exports